import createLucideIcon from '../createLucideIcon';

const Crown = createLucideIcon('Crown', [
  ['path', { d: 'm2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14', key: 'zkxr6b' }],
]);

export default Crown;
